import { useCreateManualFormModal } from '~/components/Modals/ManualFormModal';
import { useAppNavigation } from '~/hooks/nav.hook';
import { translate } from '~/utils/translation.utils';

export const useBookingByFullNameInputModal = () => {
  const navigation = useAppNavigation();

  return useCreateManualFormModal({
    title: translate('bookings.bookingsByName'),
    subtitle: translate('bookings.enterSearchDetails'),
    formData: [
      {
        items: [
          {
            type: 'text',
            label: translate('bookings.firstName'),
            id: 'firstName',
          },
        ],
      },
      {
        items: [
          {
            type: 'text',
            label: translate('bookings.lastName'),
            id: 'lastName',
          },
        ],
      },
      // {
      //   items: [
      //     {
      //       type: 'number',
      //       label: translate('bookings.maxDistance'),
      //       id: 'maxDistance',
      //       optional: true,
      //     },
      //   ],
      // },
    ],
    onConfirm: (value) => {
      navigation.navigate('BookingsByName', value);
    },
  });
};
